angular.module('qkr').controller('LoyaltyCardProductSelectorController', ($scope, $uibModalInstance,
                                                                          preSelectedProducts, productList,
                                                                          gettextCatalog, lockedProducts) => {
    $scope.init = function() {
        $scope.productList = [];
        $scope.categoryList = [];

        $scope.productList = angular.copy(productList);

        if (preSelectedProducts.length > 0) {
            $scope.isEdit = true;
        }

        angular.forEach($scope.productList, (prod) => {
            prod.selected = 0;
            prod.showVariants = false;

            // Set locked
            for (var i = 0; i < lockedProducts.length; i++) {
                if (lockedProducts[i].id == prod.id) {
                    prod.loyaltyCardName = lockedProducts[i].loyaltyCardName;
                    prod.selected = 2;
                    break;
                }
            }

            for (var i = 0; i < preSelectedProducts.length; i++) {
                if (preSelectedProducts[i].id == prod.id) {
                    prod.selected = 1;
                    break;
                }
            }

            let catExists = -1;

            for (var i = 0; i < $scope.categoryList.length; i++) {
                if ($scope.categoryList[i].name == prod.category.name) {
                    catExists = i;
                    break;
                }
            }

            if (catExists > -1) {
                $scope.categoryList[catExists].products.push(prod);
            } else {
                const newEntry = {
                    id: prod.category.id,
                    name: prod.category.name,
                    selected: 0,
                    showProducts: true,
                    products: [prod]
                };

                $scope.categoryList.push(newEntry);
            }
        });

        angular.forEach($scope.categoryList, (category) => {
            $scope.allProductsSelected(category);
        });
    },

    $scope.categorySelect = function(category) {
        angular.forEach(category.products, (prod) => {
            if (prod.selected != 2) {
                prod.selected = category.selected;
            }
        });
    },

    // Check category is all products are selected
    $scope.allProductsSelected = function(cate) {
        let selected = 0;
        let lockSelected = 0;

        angular.forEach(cate.products, (product) => {
            if (product.selected == 1) {
                selected++;
            }
            if (product.selected == 2) {
                lockSelected++;
            }
        });
        if (selected == cate.products.length) {
            cate.selected = 1;
            return;
        }
        if (lockSelected == cate.products.length) {
            cate.selected = 2;
            return;
        }
        cate.selected = 0;
        return;
    },

    $scope.validate = function() {
        $scope.errors = {};

        for (let c = 0; c < $scope.categoryList.length; c++) {
            if ($scope.categoryList[c].selected == 1) {
                return true;
            }
            for (let p = 0; p < $scope.categoryList[c].products.length; p++) {
                if ($scope.categoryList[c].products[p].selected == 1) {
                    return true;
                }
            }
        }

        $scope.errors.noneSelected = gettextCatalog.getString('At least one product must be selected');
        return false;
    },

    $scope.cancel = function() {
        $uibModalInstance.close('cancel');
    },

    $scope.save = function() {
        if (!$scope.validate()) {
            return;
        }

        $uibModalInstance.close($scope.categoryList);
    };
});



// WEBPACK FOOTER //
// ./src/loyalty/controllers/loyaltyCardProductSelector.controller.js